<template>
  <List :searchBox="searchBox" :fullscreen="fullscreen">
    <v-list-item-group v-if="items.length" color="primary">
      <ListItemAvatarTwoL
        v-for="(item, i) of items"
        :key="i"
        :title="item[itemTitle]"
        :subtitle="item[itemSubtitle]"
        @clicked="$emit('clicked', item)"
      />
    </v-list-item-group>
    <p v-else class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
  </List>  
</template>

<script>
import List from './List';
import ListItemAvatarTwoL from './ListItemAvatarTwoL';

export default {
  name: 'ListTwoLItemsSelect',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    itemSubtitle: {
      type: String,
      default: ''
    },
    searchBox: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    List,
    ListItemAvatarTwoL
  }
}
</script>

<style>

</style>